export const HEALTH_MONITOR_ACTION = {
  // List
  GET_HEALTH_MONITOR_SETTINGS: 'GET_HEALTH_MONITOR_SETTINGS',
  GET_HEALTH_MONITOR_SETTINGS_SUCCESS: 'GET_HEALTH_MONITOR_SETTINGS_SUCCESS',
  GET_HEALTH_MONITOR_SETTINGS_ERROR: 'GET_HEALTH_MONITOR_SETTINGS_ERROR',

  // Update (upsert per entity)
  UPDATE_HEALTH_MONITOR_SETTING: 'UPDATE_HEALTH_MONITOR_SETTING',
  UPDATE_HEALTH_MONITOR_SETTING_SUCCESS:
    'UPDATE_HEALTH_MONITOR_SETTING_SUCCESS',
  UPDATE_HEALTH_MONITOR_SETTING_ERROR: 'UPDATE_HEALTH_MONITOR_SETTING_ERROR',
  UPDATE_HEALTH_MONITOR_SETTING_CLEAN_STATE:
    'UPDATE_HEALTH_MONITOR_SETTING_CLEAN_STATE',
};

// =========================================================================
// List health monitor settings
export const getHealthMonitorSettings = () => ({
  type: HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS,
});

export const getHealthMonitorSettingsSuccess = (data) => ({
  type: HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS_SUCCESS,
  payload: data,
});

export const getHealthMonitorSettingsError = ({ message }) => ({
  type: HEALTH_MONITOR_ACTION.GET_HEALTH_MONITOR_SETTINGS_ERROR,
  payload: message,
});

// =========================================================================
// Update a health monitor setting
// data: { entityType, entityId, monitoringEnabled, thresholdSeconds? }
export const updateHealthMonitorSetting = (data) => ({
  type: HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING,
  payload: data,
});

export const updateHealthMonitorSettingSuccess = (data) => ({
  type: HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_SUCCESS,
  payload: data,
});

export const updateHealthMonitorSettingError = ({ message }) => ({
  type: HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_ERROR,
  payload: message,
});

export const updateHealthMonitorSettingCleanState = () => ({
  type: HEALTH_MONITOR_ACTION.UPDATE_HEALTH_MONITOR_SETTING_CLEAN_STATE,
});
